import { CaseDuplicateType, CaseStatus, OrganType } from '@/api/apis/case';
import { useAllDuplicatesListQuery } from '@/queries/case';

type UseCaseDuplicatesListParams = {
  enabled?: boolean;
  relatedToCaseId?: string;
  donorId?: string;
  organType?: OrganType;
};

type UseCaseDuplicatesListResult = {
  isFetching: boolean;
  hasDuplicates: boolean;
  duplicates: CaseDuplicateType[];
  relatedDuplicates: CaseDuplicateType[];
};

const DEFAULT_PARAMS = { enabled: true };

export const useCaseDuplicatesList = (
  params: UseCaseDuplicatesListParams = DEFAULT_PARAMS,
): UseCaseDuplicatesListResult => {
  const { data: { items: duplicates = [] } = {}, isFetching } = useAllDuplicatesListQuery({ enabled: params.enabled });

  const relatedDuplicates = params.relatedToCaseId
    ? duplicates.filter(
        (c) =>
          c.status !== CaseStatus.Deleted &&
          c.caseId !== params.relatedToCaseId &&
          c.donorId?.toUpperCase() === params.donorId?.toUpperCase() &&
          c.organType === params.organType,
      )
    : [];

  return {
    hasDuplicates: relatedDuplicates.length > 0,
    relatedDuplicates,
    isFetching,
    duplicates,
  };
};
